import { render, staticRenderFns } from "./AssignPccUserDeposits.vue?vue&type=template&id=20acdc3a&scoped=true&"
import script from "./AssignPccUserDeposits.vue?vue&type=script&lang=ts&"
export * from "./AssignPccUserDeposits.vue?vue&type=script&lang=ts&"
import style0 from "./AssignPccUserDeposits.vue?vue&type=style&index=0&id=20acdc3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20acdc3a",
  null
  
)

export default component.exports